import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from "./components/Header";
import Layout from './components/Layout';
import TripPlanner from './components/TripPlanner';
import { UserProvider } from './components/UserContext';
import SignIn from './components/SignIn';
import Register from './components/Register';
import VerifyLogin from './components/VerifyLogin';
import VerifyRegister from './components/VerifyRegister';
import MapView from './components/MapView';
import Weather from './components/Weather';
import FlightSearch from './components/FlightSearch';
import Waitlist from './components/Waitlist';
import Profile from './components/Profile';
import Feedback from './components/Feedback';





function App() {
  return (
    <UserProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<TripPlanner />} />
            <Route path="/map" element={<MapView />} />
            <Route path="/weather" element={<Weather />} />
            <Route path="/flight-search" element={<FlightSearch />} />
            <Route path="/waitlist" element={<Waitlist />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/verify-login/:token" element={<VerifyLogin />} />
            <Route path="/verify-email/:token" element={<VerifyRegister />} />
            <Route path="/register" element={<Register />} />
            <Route path="/feedback" element={<Feedback />} />
          </Routes>
        </Layout>
    </UserProvider>
  
  );
}

export default App;